import { HttpClient, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import {
  catchError,
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  filter,
  lastValueFrom,
  Observable,
  of,
  pairwise,
  startWith,
  Subscription,
  take,
} from 'rxjs';
import { GeneralSnackComponent } from '../components-generals/general-snack/general-snack.component';
// import { AddressInfo } from './input-funtion.service';
import { environment } from '../../../environments/environment';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  public URL_API = environment.apiURLNew;
  public generalEvent = new EventEmitter<any>();
  constructor(
    private router: Router,
    private http: HttpClient,
    private matSnackBar: MatSnackBar,
    private location: Location,
  ) {}

  public buildParams(filters: any): HttpParams {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params = params.set(key, value.toString());
      }
    });
    return params;
  }

  public buildParamsString(filters: any): HttpParams {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, value.toString());
      }
    });
    return params;
  }

  public async getServices<T extends readonly [...Observable<any>[]]>(
    observables: T,
  ): Promise<{ [K in keyof T]: T[K] extends Observable<infer R> ? R : never }> {
    return (await lastValueFrom(combineLatest(observables))) as any;
  }

  public goToUrl(
    route: string[],
    queryParams: { [key: string]: string | number },
    newParas?: boolean,
  ): void {
    window.scrollTo({ top: 0 });
    newParas
      ? this.router.navigate(route, {
          queryParams,
        })
      : this.router.navigate(route, {
          queryParams,
          queryParamsHandling: 'merge',
        });
  }

  public goToUrlSilent(
    route: string[],
    queryParams: { [key: string]: string | number },
    newParas?: boolean,
  ): void {
    window.scrollTo({ top: 0 });
    const urlTree = this.router.createUrlTree(route, {
      queryParams,
      queryParamsHandling: newParas ? null : 'merge',
    });
    const url = this.router.serializeUrl(urlTree);
    this.location.go(url);
  }

  public subscribeForm(formGroup: FormGroup | FormControl): Observable<[any, any]> {
    return formGroup.valueChanges.pipe(
      startWith(formGroup.value), // Emitir el valor inicial
      debounceTime(700), // Esperar 700 ms tras cada cambio
      distinctUntilChanged(), // Ignorar valores idénticos
      pairwise(), // Obtener valor anterior y actual
      filter(([prev, current]) => JSON.stringify(prev) !== JSON.stringify(current)), // Validar si realmente cambió
    );
  }

  public subscribeFormSimple(
    formGroup: FormGroup | FormControl | AbstractControl,
  ): Observable<any> {
    return formGroup.valueChanges.pipe(
      startWith(formGroup.value), // Emitir el valor inicial
      debounceTime(600), // Esperar 700 ms tras cada cambio
      distinctUntilChanged(), // Ignorar valores idénticos
    );
  }

  public unsubscribeAll(subscribeArray: Subscription[]): void {
    subscribeArray.forEach((sub) => sub.unsubscribe());
  }

  // Trasforma un Json a string
  public jsonToString(data: any): string {
    return JSON.stringify(data);
  }
  // Trasforma un string a Json
  public stringToJson(jsonString: string | null): any {
    try {
      return JSON.parse(jsonString ?? '');
    } catch (error) {
      return null;
    }
  }

  // Muestra una Alerta y un texto ( normal , error y alerta)
  public async viewSnacAlert(text: string, type: 'normal' | 'error' | 'alert', tilule: string) {
    this.matSnackBar.openFromComponent(GeneralSnackComponent, {
      duration: 5000,
      panelClass: ['panel-snack-general'],
      data: {
        type: type,
        icon: 'close',
        text: tilule,
        suptext: text,
        body: true,
      },
    });
  }

  public getEstadosSepomex(): Observable<
    {
      description: string;
      id: number;
      value: string;
    }[]
  > {
    return this.http.get<
      {
        description: string;
        id: number;
        value: string;
      }[]
    >(`${environment.apiURLNew}/getEstadosSepomex`);
  }

  public parseDate(value: string): Date | null {
    const cleanValue = value.replace(/\s+/g, ' ').trim();

    const formats = [
      'YYYY-MM-DDTHH:mm:ss.SSSZ',
      'YYYY-MM-DDTHH:mm:ss',
      'YYYY-MM-DD HH:mm:ss',
      'MMM DD YYYY hh:mmA',
      'MMM DD YYYY h:mmA',
      'YYYY-MM-DD',
    ];

    for (const format of formats) {
      const parsed = dayjs(cleanValue, format, true);
      if (parsed.isValid()) {
        return parsed.toDate();
      }
    }

    return null;
  }

  public getUserId(): number {
    const userId = localStorage.getItem('userId');
    return userId ? parseInt(userId, 10) : 0;
  }

  public emitGeneralEvent(data: any): void {
    this.generalEvent.emit(data);
  }
}
